import React from 'react';
import { useNetwork, useSwitchNetwork } from 'wagmi';
import { Badge, Button, HStack, Text, useToast, Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FiWifi, FiWifiOff } from 'react-icons/fi';

const NetworkStatus: React.FC = () => {
  const { chain } = useNetwork();
  const { switchNetwork } = useSwitchNetwork();
  const toast = useToast();
  const { t } = useTranslation('common');

  const isBscTestnet = chain?.id === 97;

  const handleSwitchToBscTestnet = () => {
    if (switchNetwork) {
      switchNetwork(97);
      toast({
        title: t('network.switchNetwork'),
        description: t('network.switchingToBsc'),
        status: 'info',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (!chain) {
    return (
      <HStack spacing={2}>
        <FiWifiOff color="gray" />
        <Text fontSize="sm" color="gray.500">
          {t('network.notConnected')}
        </Text>
      </HStack>
    );
  }

  if (isBscTestnet) {
    return (
      <HStack spacing={2}>
        <FiWifi color="green" />
        <Badge colorScheme="green" variant="subtle">
          {t('network.bscTestnet')}
        </Badge>
      </HStack>
    );
  }

  return (
          <HStack spacing={2}>
        <FiWifi color="orange" />
        <Text fontSize="sm" color="orange.500">
          {t('network.currentNetwork')}: {chain.name}
        </Text>
        <Button
          size="xs"
          colorScheme="blue"
          onClick={handleSwitchToBscTestnet}
        >
          {t('network.switchToBsc')}
        </Button>
      </HStack>
  );
};

export default NetworkStatus; 